<template>
  <a-form-model
    ref="ruleForm"
    :model="form"
    :rules="rules"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    class="formStyle"
  >
    <a-form-model-item label="是否有上级" prop="isHaveFather">
      <a-radio-group v-model="form.isHaveFather">
        <a-radio :value="1">是</a-radio>
        <a-radio :value="2">否</a-radio>
      </a-radio-group>
    </a-form-model-item>
    <a-form-model-item
      v-if="form.isHaveFather == 1"
      ref="pid"
      label="上级名称"
      prop="pid"
    >
      <a-select v-model="form.pid">
        <a-select-option v-for="item in list" :key="item.id" :value="item.id">{{
          item.name
        }}</a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item ref="name" label="类型名称" prop="name">
      <a-input v-model="form.name" />
    </a-form-model-item>
    <a-form-model-item
      prop="finance_source_ids"
      label="渠道"
      v-if="form.isHaveFather == 1"
    >
      <a-checkbox-group v-model="form.finance_source_ids">
        <a-checkbox :value="1">电脑端</a-checkbox>
        <a-checkbox :value="2">手机端</a-checkbox>
      </a-checkbox-group>
    </a-form-model-item>
    <a-form-model-item :wrapper-col="{ span: 12, offset: 5 }">
      <a-button @click="resetForm">重置</a-button>
      <a-button style="margin-left: 20px;" type="primary" @click="onSubmit"
        >提交</a-button
      >
    </a-form-model-item>
  </a-form-model>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 8 },
      other: "",
      form: {
        name: "",
        isHaveFather: "",
        pid: "",
        finance_source_ids: []
      },
      list: [],
      details: {},
      rules: {
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur"
          }
        ],
        isHaveFather: [
          {
            required: true,
            message: "请选择是否有上级",
            trigger: "change"
          }
        ],
        pid: [
          {
            required: true,
            message: "请选择上级",
            trigger: "change"
          }
        ],
        finance_source_ids: [
          {
            required: true,
            message: "请选择费用类型",
            trigger: "change"
          }
        ]
      }
    };
  },
  mounted() {
    this.getParents(); //获取费用大类
    if (this.editDetail != undefined) {
      this.details = this.editDetail;
      this.getDetails();
    }
  },
  props: {
    editDetail: {}
  },
  watch: {
    editDetail() {
      this.details = this.editDetail;
      this.getDetails();
    }
  },
  methods: {
    getDetails() {
      if (this.details.pid != 0) {
        this.form = {
          name: this.details.name,
          isHaveFather: 1,
          pid: this.details.pid,
          finance_source_ids:
            this.details.finance_source_ids == undefined &&
            this.details.finance_source_ids == ""
              ? []
              : this.details.finance_source_ids.split(",").map(Number)
        };
      } else {
        this.form = {
          name: this.details.pname,
          isHaveFather: 2,
          pid: "",
          finance_source_ids:
            this.details.finance_source_ids == undefined &&
            this.details.finance_source_ids == ""
              ? []
              : this.details.finance_source_ids.split(",").map(Number)
        };
      }
    },
    selectType() {
      this.getParents(); //获取费用大类
      this.form = {
        name: "",
        pid: ""
      };
    },
    getParents() {
      let url =
        this.httpsBasic.url + this.httpsBasic.finance + "Finance_type/getLeave";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        pid: 0
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data;
          // console.log(this.list);
        }
      });
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let params = {
            token: window.localStorage.getItem("xnwfPcToken"),
            name: this.form.name,
            pid: this.form.pid,
            id: this.details.id,
            finance_source_ids: JSON.stringify(this.form.finance_source_ids)
          };
          if (this.form.isHaveFather == 2) {
            delete params.pid;
          }
          // console.log(params);
          let url =
            this.httpsBasic.url + this.httpsBasic.finance + "Finance_type/edit";
          axios
            .post(url, params)
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success("提交成功");
                this.$emit("hideInEdit", false);
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("服务器出错了...");
            });
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    }
  }
};
</script>
<style lang="less" scoped>
.formStyle {
  margin-top: 50px;
}
</style>
